import { FC, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import commstyles from '../CommunityView/styles.module.scss';
import { request } from '../../api';
import { showFullscreenMessage } from '../../components/FullscreenMessage';
import { Button, Grid, Segment } from '../../kit';
import Avatar from '../../components/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

const EventDetailView: FC = () => {
    const [ event, setEvent ] = useState<any>();

    const fetch = (): void => {
        request.get('events').then(({ data }) => {
            data.data.map((o: any) => {
                if (window.location.href.includes(`event-${o.id}`)) {
                    setEvent(o);
                }
            });
        });
    }
    useEffect(() => fetch(), []);

    const subscribe = (event: any): void => {
        request.post(`events/${event.id}/subscribe`).then(({ data }) => {
            fetch();
            showFullscreenMessage(`Je hebt je ${data.copy}!`);
        });
    }

    return event ? (<>
        <h2 className={styles.back}>
            <span onClick={() => window.location.href = `/community/events/`}>
                <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 16 }} />
                Terug
            </span>
            {event.title}
            <span></span>
        </h2>
        <div className="container" style={{ maxWidth: 1140 }}>
            <Grid.Row>
                <Grid.Column lg={8}>
                    <Segment>
                        <div className={styles.event}>
                            <div>
                                <div className={styles.eventDate}>
                                    <span>{event.day}</span>
                                    {event.month}
                                </div>
                                <div className={styles.eventMeta}>
                                    {event.time}, {event.location}
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: 16 }}>
                            <div dangerouslySetInnerHTML={{ __html: event.description }} />
                        </div>
                    </Segment>
                </Grid.Column>
                <Grid.Column lg={4}>
                    <Segment>
                        <Button
                            color={event.subscribed ? "white" : "primary"}
                            label={event.subscribed ? 'Je bent aangemeld' : 'Ik ben erbij!'}
                            onClick={() => subscribe(event)}
                        />
                    </Segment>
                    {event.coaches.length > 0 && (<>
                        <h2 style={{ marginTop: 32 }}>Deelnemers</h2>
                        {event.coaches.map((profile: any) => (
                            <Segment
                                key={`profile-${profile.id}`}
                                className={commstyles.profile}
                                onClick={() => (window as any).location.href = `/community/${profile.permalink}`}
                            >
                                <Avatar profile={profile} />
                                <div className={commstyles.profileMeta}>
                                    <a href={`/community/${profile.permalink}`}>{profile.name}</a><br />
                                    {profile.organisation}
                                </div>
                            </Segment>
                        ))}
                    </>)}
                </Grid.Column>
            </Grid.Row>
        </div>
    </>) : null;
}

export default EventDetailView;
